import { faBed, faCalendarAlt, faEllipsisVertical, faSearch, faVenus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Card, Col, Container, Dropdown, Form, Image, Row } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { Card1, SearchFilter } from "../../../../assets/images";
import { dateFormat, renderImage } from "../../../Helper/General";
import * as Constants from '../../../Helper/constants/constants';
import WithoutImageHeader from "../../../Helper/withoutImageHeader";
import PaginationComponent from "../../CommanComponents/Pagination";
import FilterModal from "../../Modals/FilterModal";
import TaskModal from "../../Modals/TaskModal/index";
import PatientListFunctions from "./functions";
import NoDataComponent from "../../CommanComponents/NoDataComponent";

const PatientList = () => {
    const {
        setShowFilterModal,
        showFilterModal,
        searchInput,
        handleChange,
        getPatientListing,
        patientListing,
        navigate,
        loader,
        page,
        handlePages,
        totalPages,
        handleNextClick,
        handleBackClick,
        wardActivePatient,
        patientStatus,
        setPatientStatus,
        chnagePatientStatus,
        searchPatient,
        handleBreadcrumDataNaviagtion,
        wardId,
        setWardID
    } = PatientListFunctions();

    const loaction = useLocation();
    const [breadcrumData, setbreadcrumData] = useState(['Dashboard']);
    var breadcrumItem = 'Patient List';
    
    useEffect(() => {
        setWardID(loaction && loaction.state && loaction.state.item && loaction.state.item.id)
        if (loaction && loaction.state) {
            let array = [...breadcrumData]
            let name = loaction && loaction.state && loaction.state.item && loaction.state.item.title
            if (array) {
                array.push(name)
            }
            else {
                array.push('Ward')
            }
            setbreadcrumData(array);
        }
        getPatientListing('', 1, loaction && loaction.state && loaction.state.item && loaction.state.item.id ? loaction.state.item.id : 1);
    }, []);

    
    return (
        <>
            <div className="patient_list_screen">
                <WithoutImageHeader
                    header={Constants.PATIENT_LIST_HEADER}
                    breadcrumData={breadcrumData}
                    breadcrumItem={breadcrumItem}
                    handleBack={() => navigate(-1)}
                     handleBreadcrumDataNaviagtion={(i) =>
                    handleBreadcrumDataNaviagtion(i)
                }
                />
                <Container>
                    <Row>
                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                            <div className="patient_details">
                                <div className="search_section">
                                    <div className="search_area">
                                        <Form>
                                            <Form.Group className="form-group">
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Search"
                                                    value={searchInput}
                                                    onChange={(e) => searchPatient(e.target.value, wardId)}
                                                />
                                                <a href="javascript:;">
                                                    <div className="icon">
                                                        <FontAwesomeIcon icon={faSearch} />
                                                    </div>
                                                </a>
                                            </Form.Group>
                                        </Form>
                                    </div>
                                    <a href="javascript:;">
                                        <div className="filter_area">
                                            <div className="img_area" onClick={() => setShowFilterModal(true)}>
                                                <Image src={SearchFilter} alt="..." />
                                            </div>
                                        </div>
                                    </a>
                                </div>
                                <div className="active_area">
                                    {patientListing && patientListing.length > 0 ? <p>Active Patient : {wardActivePatient ? wardActivePatient : 0}</p> : null}
                                </div>
                                {
                                    patientListing && patientListing.length > 0 ?
                                        patientListing.map((item, i) => {
                                            return (
                                                <Card key={i}>
                                                    <Card.Body >
                                                        <div className="card_left">
                                                            <div className="img_area">
                                                                <Card.Img variant="left" src={item && item.image ? renderImage(item.image) : null } alt="..." onClick={() => navigate(`/patientDetails`, { state: { id: item.id, pageParams: breadcrumData, name: item.name } })} />
                                                            </div>
                                                        </div>
                                                        <div className="card_right">
                                                            <div className="personal_data">
                                                                <div className="name_number_area">
                                                                    <div className="data">
                                                                        <h3 onClick={() => navigate(`/patientDetails`, { state: { id: item.id, pageParams: breadcrumData, name: item.name } })}>{item.patient_name}</h3>
                                                                        <span>
                                                                            {
                                                                                item.uh_id ?
                                                                                    <p>MR : {item.uh_id}</p>
                                                                                    :
                                                                                    null
                                                                            }

                                                                            <Dropdown>
                                                                                {
                                                                                item.patient_status !== "discharge" ?
                                                                                <Dropdown.Toggle variant="none" id="dropdown-basic">
                                                                                <FontAwesomeIcon icon={faEllipsisVertical} className="ellipsis_icon" />
                                                                                </Dropdown.Toggle>
                                                                                        : null
                                                                                }
                                                                               
                                                                                {item.patient_status !== "discharge" ?
                                                                                    <Dropdown.Menu>
                                                                                        {patientStatus.map((ditem, index) => (
                                                                                            <Dropdown.Item key={index}
                                                                                                onClick={(e) => {
                                                                                                    e.preventDefault();
                                                                                                    chnagePatientStatus(item.id, ditem.id, wardId)
                                                                                                }
                                                                                                }>
                                                                                                {ditem.value}
                                                                                            </Dropdown.Item>
                                                                                        ))}
                                                                                    </Dropdown.Menu> : null}
                                                                            </Dropdown>
                                                                        </span>
                                                                    </div>

                                                                </div>
                                                                <p><span>{item.ward_name ? item.ward_name : 'Ward'}</span></p>
                                                                <div className="gender_area">
                                                                    {
                                                                        item.gender ?
                                                                            <p><FontAwesomeIcon icon={faVenus} className="gender_icon" />{item.gender ? item.gender : 'gender'}</p>
                                                                            :
                                                                            null
                                                                    }
                                                                    <p><FontAwesomeIcon icon={faBed} className="date_icon ps-4" />Bed #{item.bed_number ? item.bed_number : '0'}</p>
                                                                </div>
                                                                <div className="date_information">
                                                                    {
                                                                        item.created ?
                                                                            <div className="date">
                                                                                <FontAwesomeIcon icon={faCalendarAlt} className="date_icon" />
                                                                                <p>{dateFormat(item.created)}</p>
                                                                            </div>
                                                                            :
                                                                            null

                                                                    }
                                                                    {
                                                                        item.patient_status ?
                                                                            <div className={item.patient_status === "admitted" ? "badge success" : item.patient_status === "under_treatment" ? "badge" : item.patient_status === "critical" ? "badge critical" : "badge"}>
                                                                                <p>{item.patient_status}</p>
                                                                            </div>
                                                                            :
                                                                            null
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Card.Body>
                                                </Card>
                                            )
                                        })
                                        :
                                        <>
                                            {!loader ?
                                                <NoDataComponent
                                                    message="No Patient Found!"
                                                /> : null}
                                        </>
                                }
                            </div>
                        </Col>
                    </Row>
                </Container>

                {
                    showFilterModal ? (
                        <FilterModal show={showFilterModal} close={() => setShowFilterModal(false)} />
                    ) : null
                }

            </div >
            {
                !loader && patientListing && patientListing.length > 0 ? <PaginationComponent
                    page={page}
                    setPage={handlePages}
                    totalPages={totalPages}
                    handleBackClick={handleBackClick}
                    handleNextClick={handleNextClick}
                /> : null}

                {/* <Viewfile/> */}
        </>
    )
}

export default PatientList;